module.exports = __webpack_public_path__ + "static/img/industryCenter.b8ae714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/industryCenter.png
// module id = GSjc
// module chunks = 44